// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.placeholder-container div[data-v-1fda87ac] {\r\n  margin: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
